import CONSTANTS from "../Constants";

const isCurrencyBeforePrice = !!Number(window.siteConfig.PoundPlacement);

export function isMobile() {
    let isMobile = false
    if (window.innerWidth <= 800) {
        isMobile = true;
    }
    return isMobile
}
export function removeNumbers(oldValue) {
    var newValue = ''
    newValue = oldValue.replace(/[0-9]/g, '')
    return newValue
}
export function priceFormat(price) {
    return isCurrencyBeforePrice ? `${CONSTANTS.LABELS.common_v2_currency}${price}` : `${price} ${CONSTANTS.LABELS.common_v2_currency}`
}

export function getNewPhoneFormatValue(oldValue) {
    var newValue = ''
    newValue = oldValue.replace(/[^0-9\s\.]/g, '')
    newValue = reformatPhoneValueAccordingPhoneMask(newValue, CONSTANTS.SITE_INFO.PHONEMASK)
    return newValue
}
function reformatPhoneValueAccordingPhoneMask(oldValue, phoneMask) {
    var reformatedValue = ''
    if (phoneMask && oldValue) {
        var j = 0
        for (var i = 0; i < oldValue.length && j < phoneMask.length; i++) {
            if (oldValue[i] !== ' ' && phoneMask[j] !== ' ') {
                reformatedValue += oldValue[i]
                j++
            } else if (oldValue[i] !== ' ' && phoneMask[j] === ' ') {
                reformatedValue += ' ' + oldValue[i]
                j += 2
            } else if (oldValue[i] === ' ' && phoneMask[j] === ' ') {
                reformatedValue += oldValue[i]
                j++
            }
        }
        if (phoneMask && reformatedValue.length > phoneMask.length) { reformatedValue = reformatedValue.substring(0, phoneMask.length) }
    } else if (!phoneMask) {
        reformatedValue = oldValue
    }
    return reformatedValue
}